import { render, staticRenderFns } from "./PPublicIcon.vue?vue&type=template&id=5408d010&scoped=true&"
import script from "./PPublicIcon.vue?vue&type=script&lang=ts&"
export * from "./PPublicIcon.vue?vue&type=script&lang=ts&"
import style0 from "./PPublicIcon.vue?vue&type=style&index=0&id=5408d010&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5408d010",
  null
  
)

export default component.exports

/* vuetify-loader */
import installDirectives from "!../../../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import Ripple from 'vuetify/lib/directives/ripple'
installDirectives(component, {Ripple})
